import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchTitleImportEvents, } from "../api/titleImportService";
var POLL_INTERVAL = 3000;
export var useTitleImportEvents = function (_a) {
    var fileName = _a.fileName, severity = _a.severity, query = _a.query, page = _a.page, size = _a.size, refetchWhileRunning = _a.refetchWhileRunning;
    var kyInstance = useOkapiKy();
    return useQuery(["title-import-events", fileName, severity, query !== null && query !== void 0 ? query : "", page, size], function () {
        return fetchTitleImportEvents(kyInstance, {
            fileName: fileName,
            severity: severity,
            query: query,
            page: page,
            size: size,
        });
    }, {
        enabled: !!fileName,
        keepPreviousData: true,
        retry: 1,
        refetchInterval: refetchWhileRunning ? POLL_INTERVAL : false,
    });
};
